export default async (text, callback, successMessage) => {
    await navigator.clipboard.writeText(text);
    successMessage && callback(successMessage, 'success');
};
